// @flow
import React from "react";
import Logo from "./Logo";

import logo from "./logo.svg";
import logoMobile from "./logo-small.png";
// import errorBg from "./error-bg.png";
import indexLogo from "./index-logo.svg";
import indexLogoText from "./index-logo-text.svg";
import indexHeaderBackground from "./header.jpg";
import refLogo from "../../components/Regbonus/images/ref_img/logo_siam.png";
import howToBackground from "../../images/howto-bg.jpg";
import desktopTourBg from "../../images/desktop-tour-bg-th.jpg";
import { rgba } from "polished";

const basic = {
  direction: "ltr",
  // основной шрифт
  fontFamily: "Roboto, Arial, sans-serif",
  // логотип
  logo: <Logo />,
  logoImg: logo,
  logoImgMobile: logoMobile,
  // errorBg: errorBg,

  // ЦВЕТА
  // основной
  main: "#362f42",
  mainDark: "#332b3b", // шапка
  mainLight: "#463e54", // сайдбар
  mainHighlight: "#3c3446",
  mainFontColor: "#38465d",
  mainSeparator: "#403949",

  mode: "dark",
  foreground: "#fff",
  alternativeForeground: "#ffffff",
  lightWhiteForeground: "#ffffff",
  background: "#000",
  mainColorBackground: "#362f42",
  secondaryColorBackground: "#362f42",

  ticksFontColor: "#7c7686",
  borderMainColor: "#6b6575",
  ticksBorderColor: "#6e6976",

  accent: "#feac00",
  alternativeAccent: "#feac00",
  lightWhiteAccent: "#feac00",
  accentOpacity: "rgba(254, 172, 0, .5)",
  secondaryTextColor: "#99959d",

  upper: "#60a31c", // positive ставки
  alternativeUpper: "#60a31c",
  upperAccent: "#72c121",
  upperBorder: "#4f8618",
  upperBoxShadow: "#62bb03",

  lower: "#e74c3c", // negative ставки
  lowerAccent: "#da5c5c",
  lowerBorder: "#af3333",
  lowerBoxShadow: "#d45757",

  // анимации для попапов
  perspective: "1300px",
  showAnimation: ".15s linear 1",

  // переменные для вёб морды
  indexMajor: "#4e2a81",
  indexMinor: "#30174e",
  indexLogo: indexLogo,
  indexLogoText: indexLogoText,
  headerLogoText: indexLogoText,
  indexHeaderBackground: indexHeaderBackground,
  howToBg: howToBackground,

  // переменные хелпдеска
  helpdeskSeparator: "#514268",
  helpdeskMobileMenuSeparator: "#452e61",
  helpdeskNavlinks: "#9b8baf",

  // переменные для страницы /regbonus
  refHeader: "#30174e",
  refLogo: refLogo,
  refLogoText: null,
  refFooterBorder: "#7b61a2",
  refFooterColor: "#d7cde5",
  refConditionBg: "#4c297e",
  refInvestmentBg: "#3e2166",

  //попап досрочной продажи
  sellDealBg: "#55476d",
  sellDealBorder: "#41335d",
  sellDealProfitColor: "#ffffff",
  sellDealButtonColor: "#ffcc00",
  sellDealHistoryBg: "#3d4149",
  sellDealHistoryColor: "#ffcc00",
  sellDealHistoryProgress: "#5d6067",

  // переменные статичных страниц
  staticHeaderLink: "#9b8baf",

  toggleAccountLightBg: "#3c3446",
  toggleAccountDarkBg: "#332b3b",

  popupBackground: "#332b3b",
  popupDarkBackground: "#3c3446",

  desktopTourBg: desktopTourBg,
  minFontSize: "16px",
  textMuted: "#99959d",
  mainLink: "#0085eb",

  tradeHeaderAccent: "#feac00",
  dealsBackground: "#332b3b",
  dealIconColor: "#ffffff",
  barCaption: rgba("#feac00", 0.28),
  cursorBarCaption: "#5D6067",
  bottomNavigationBg: rgba("#ffffff", 0.4),
  stockInfoBg: "#3c3446",

  tournamentPopupBgLight: "#3c3446",
  tournamentPopupBgDark: "#332b3b",
  tournamentCardBg: "#332b3b",
  tournamentCardMainColor: "#ffffff",
  tournamentCardSecondaryColor: "#feac00",
  tournamentCardPlaceholder: "#feac00",

  scrollColor: "rgba(255, 255, 255, 0.5)",

  currencyColor: "#feac00",

  navigationBg: "#332B3B",
  navigationItemColor: "#9b8baf",
  navigationItemIcon: "#9b8baf",
  navigationItemActiveBg: "#3c3446",
  navigationItemIconActive: "#ffffff",

  operationChequeqColor: "#99959d",
  operationChequeColor: "#d2d2d2",

  bellNewsLinkColor: "#4e2a81",

  inputColor: "#4e2a81",

  oneSignalHeaderBg: "#4e2a81",

  languageBackground: "#3c3446",
  languageColor: "#ffffff",
  languageArrowColor: rgba("#fff", 0.7),
  sightseeingBigBg: "rgba(255, 255, 255, 0.1)",
  sightseeingSmallBg: "rgba(255, 255, 255, 0.05)",
  sightSeeingImageShadow: "rgba(255, 255, 255, 0.2)",
  sightseeingBg: "linear-gradient(to bottom, #32273e 0%, #453950 100%)",
  sightSeeingBgShadow: "transparent",
  sightSeeingStartButtonBg: "#feac00",
  sightSeeingStartButtonColor: "#000",
  sightseeingLater: "rgba(255, 255, 255, 0.5)",
  dotColor: "rgba(255, 255, 255, 0.5)",
  dotActiveColor: "#fff",

  suggestingInputBg: rgba("#ffffff", 0.1),
  suggestingInputBgDisabled: rgba("#ffffff", 0.25),
  suggestingInputButtonSymbol: "#ffffff",
  suggestingInputButtonSymbolDisabled: rgba("#919191", 0.59),

  mobileSwitchStockBackground: "#919191",
  mobileSwitchStockArrow: "#ffffff",

  socialTradingButtonBg: "#5E5968",
  socialTradingButtonBgHover: "#5E5968",
  socialTradingButtonBgActive: "#86828E",
  socialTradingHiddenLink: "#99959D",
  socialTradingHiddenLinkHover: "#FEAC00",
  socialTradingBg: "#463E54",
  socialTradingTableHeaderBg: "#3B3446",
  socialTradingSubtitleColor: "#99959D",

  tabsTournamentsCategoryTitle: "#ffffff",

  freeBonusPopupFontColor: "#ffffff",

  tourWitdrawMethodHover: "#feac00",

  authCurrencyCodeColor: "#1B546A",
};

export default basic;

// дополнительные темы забирают
// недостающие настройки и цвета
// из базовых

export const richblue = {
  ...basic,

  mode: "dark",
  foreground: "#fff",
  background: "#000",

  // основной цвет
  main: "#061424",
  mainDark: "#0A131E", // шапка
  mainLight: "#121B27", // сайдбар
  mainHighlight: "#162130",
  mainFontColor: "#38465d",
  mainSeparator: "#2D3244",
  secondaryTextColor: "#99959d",

  borderMainColor: "#2D3244",
  ticksBorderColor: "#2D3244",

  popupBackground: "#0A131E",
  popupDarkBackground: "#0A131E",
};

export const light = {
  ...basic,

  // основной цвет
  main: "#443B54",
  mainDark: "#3F374F", // шапка
  mainLight: "#4E4360", // сайдбар
  mainHighlight: "#51446B",
  mainFontColor: "#38465d",
  mainSeparator: "#5D4E7A",
  secondaryTextColor: "#99959d",

  borderMainColor: "#5D4E7A",
  ticksBorderColor: "#6e6976",

  popupBackground: "#3F374F",
  popupDarkBackground: "#3F374F",
};



// WEBPACK FOOTER //
// ./src/themes/siamoption/siamoption.js